import { Warehouse, CalendarRange, ShieldCheck, Sun, type LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

import useBrandName from '@/hooks/use-brand-name';

const Clause = ({ icon: Icon, title, children }: { icon: LucideIcon; title: ReactNode; children: ReactNode }) => (
    <div className="flex gap-3">
        <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10 shrink-0">
            <Icon className="w-5 h-5 text-primary" />
        </div>
        <div>
            <p className="font-semibold mb-0.5">{title}</p>
            <p className="text-sm text-muted-foreground">{children}</p>
        </div>
    </div>
);

const ClausesHivernage = () => {
    const brandName = useBrandName();
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <Clause icon={Warehouse} title="Vous n’utilisez plus votre moto en hiver ?">
                Déclarez la période pendant laquelle votre moto est remisée au garage et bénéficiez d’une réduction sur votre cotisation d’assurance.
            </Clause>
            <Clause icon={CalendarRange} title="Activable 1 seule fois">
                Pour une durée maximale de 120 jours : du 1er octobre au 1er mars de l’année suivante.
            </Clause>
            <Clause icon={ShieldCheck} title={`Le + ${brandName} : une baisse de prime sans baisse de garanties`}>
                Pendant la durée de Ma période hivernale, vous conservez les garanties de votre contrat en circulation et en stationnement.
            </Clause>
            <Clause icon={Sun} title="Reprenez le guidon quand vous voulez">
                Par une belle journée d’hiver ensoleillée, vous pouvez occasionnellement reprendre le guidon !
            </Clause>
        </div>
    );
};

export default ClausesHivernage;
